import {useAppSelector} from '../../../app/hooks/useAppSelector';
import {selectSession} from '../authSlice';

export const useSession = () => {
  return useAppSelector(selectSession);
};
